// src/presentation/pages/ClinicalExamination/sections/DepressionSection.tsx
import React from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

interface DepressionSectionProps {
  value: string;
  onChange: (value: string) => void;
}

export const DepressionSection: React.FC<DepressionSectionProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <p className="text-sm text-gray-500">
          {t("clinicalSections.depression.question")}
        </p>
      </div>
      <div>
        <RadioGroup
          value={value}
          onValueChange={onChange}
          className="space-y-3"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="not-at-all" id="depression-not" />
            <Label
              htmlFor="depression-not"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.depression.notAtAll")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="several-days" id="depression-several" />
            <Label
              htmlFor="depression-several"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.depression.severalDays")}
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="nearly-every-day" id="depression-every" />
            <Label
              htmlFor="depression-every"
              className="text-[#1B1D21] cursor-pointer text-sm font-normal"
            >
              {t("clinicalSections.depression.nearlyEveryDay")}
            </Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};
